export default "__VITE_ASSET__CJszLvwB__"